import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { Box, FlatList, HStack, Text, VStack } from "native-base";
import { forHumans } from "@madmedical/medical";
import { useTranslation } from "@madmedical/i18n";
import { useThresholdsProtocols } from "../providers/thresholdsProtocol";
import ReactTable from "../molecules/ReactTable";
import Tag from "../atoms/Tag";
import IconButton from "../atoms/IconButton";
import useResponsive from "../util/useResponsive";
import Paper from "../atoms/Paper";
import Headline from "../molecules/Headline";
const ThresholdsProtocolsTable = ({ onEditPress, title }) => {
    const { thresholdsProtocols } = useThresholdsProtocols();
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    const MobileList = () => (_jsx(FlatList, { data: thresholdsProtocols, renderItem: ({ item }) => (_jsxs(HStack, Object.assign({ space: 2 }, { children: [_jsxs(VStack, Object.assign({ flex: 1, alignItems: "flex-start", space: 2 }, { children: [_jsx(Tag, { children: forHumans(item.metricType) }), _jsx(Text, { children: item.protocol })] })), item.isThresholdEditable && onEditPress && (_jsx(IconButton, { iconName: "edit", variant: "lightGray", size: "xs", onPress: () => {
                        onEditPress(item.metricType);
                    } }))] }))) }));
    const columns = useMemo(() => [
        {
            Header: t("measures:type"),
            accessor: "metricType",
            Cell: ({ value }) => _jsx(Tag, { children: forHumans(value) }),
            width: "10%",
        },
        {
            Header: t("measures:measureProtocol"),
            accessor: "protocol",
            Cell: ({ value }) => (_jsx(Box, Object.assign({ flexShrink: 1, justifyContent: "space-between", alignItems: "center", flex: 1, flexDirection: "row" }, { children: value }))),
            width: "65%",
        },
        {
            Header: t("measures:warning"),
            id: "warningForHumans",
            accessor: "thresholds",
            Cell: ({ value }) => (_jsx(_Fragment, { children: value.map(({ type, warningForHumans }) => (_jsx(Box, Object.assign({ flexShrink: 1, justifyContent: "space-between", alignItems: "center", flex: 1, flexDirection: "row" }, { children: warningForHumans }), type))) })),
            width: "10%",
        },
        {
            Header: t("measures:alert"),
            id: "alertForHumans",
            accessor: "thresholds",
            Cell: ({ value }) => (_jsx(_Fragment, { children: value.map(({ type, alertForHumans }) => (_jsx(Box, Object.assign({ flexShrink: 1, justifyContent: "space-between", alignItems: "center", flex: 1, flexDirection: "row" }, { children: alertForHumans }), type))) })),
            width: "10%",
        },
        {
            Header: "",
            id: "action",
            Cell: ({ row }) => {
                const { metricType, isThresholdEditable } = row.original;
                return isThresholdEditable && onEditPress ? (_jsx(IconButton, { iconName: "edit", variant: "lightGray", size: "xs", onPress: () => {
                        onEditPress(metricType);
                    } })) : null;
            },
            width: "5%",
        },
    ], [onEditPress, t]);
    if (!thresholdsProtocols.length)
        return null;
    return (_jsxs(Paper, { children: [_jsx(Headline, { title: title, size: "xs" }), _jsx(Box, Object.assign({ px: 6, py: 4, w: "full" }, { children: isSmallScreen ? (_jsx(MobileList, {})) : (_jsx(ReactTable, { columns: columns, data: thresholdsProtocols })) }))] }));
};
export default ThresholdsProtocolsTable;
